export default __webpack_public_path__ + "static/media/tarea.aaf21218.PNG";